var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { jsxs, jsx } from "react/jsx-runtime";
import { Field } from "./Field.js";
import "../ValidationError/index.js";
import "../ChoiceGroup/index.js";
import { ChoiceGroup } from "../ChoiceGroup/ChoiceGroup.js";
import { ValidationError } from "../ValidationError/ValidationError.js";
class ChoiceGroupField extends Field {
  constructor() {
    super(...arguments);
    __publicField(this, "children", (fieldProps) => {
      const { meta, field } = fieldProps;
      return /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          ChoiceGroup,
          __spreadProps(__spreadValues(__spreadValues({}, this.props), field), {
            selectedKey: field.value,
            onChange: (ev, option) => this._handleChange(fieldProps, ev, option)
          })
        ),
        !!meta.touched && !!meta.error && /* @__PURE__ */ jsx(ValidationError, { children: meta.error })
      ] });
    });
    __publicField(this, "_handleChange", (props, ev, option) => {
      props.form.setFieldValue(props.field.name, option ? option.key : null, true);
      this.props.onChange && this.props.onChange(ev, option);
    });
  }
}
export {
  ChoiceGroupField
};
//# sourceMappingURL=ChoiceGroupField.js.map
